import i18n from "@microdoing/shared/i18n";
import {
  getLoginEmail,
  getLoginPasswordResetError,
  getLoginRequesting,
  getLoginResetPasswordSent,
} from "@microdoing/shared/services/login/selectors";
import { Box, MainText, RoundInput } from "app/components/common";
import OnboardingWebBody from "app/components/common/Onboarding/OnboardingWebBody";
import OnboardingWebInfo from "app/components/common/Onboarding/OnboardingWebInfo";
import React from "react";
import { useSelector } from "react-redux";

const ForgetPasswordImage = require("../../../assets/images/Forget-password.png");

interface IProps {
  onChangeEmail: (text: string) => void;
  onSubmit: () => void;
  goToLogin: () => void;
}

const WebForgotPasswordScreen = ({
  onChangeEmail,
  onSubmit,
  goToLogin,
}: IProps) => {
  const email = useSelector(getLoginEmail);
  const requesting = useSelector(getLoginRequesting);
  const passwordResetError = useSelector(getLoginPasswordResetError);
  const resetPasswordSent = useSelector(getLoginResetPasswordSent);

  return (
    <Box flex={1} justifyContent="center" backgroundColor="neutral.white">
      <Box variant="webOnboarding" flexDirection="row">
        <OnboardingWebInfo image={ForgetPasswordImage} />
        <OnboardingWebBody
          title={i18n.t("web-forget-password-title")}
          subTitle={i18n.t("web-forget-password-subtitle")}
          body={
            <>
              <Box marginBottom="xm">
                <MainText variant="l4-medium" marginBottom="xs">
                  {i18n.t("web-signup-email")}
                </MainText>
                <RoundInput
                  keyboardType="email-address"
                  onChangeText={onChangeEmail}
                  value={email}
                  placeholder={i18n.t("your-email")}
                  autoFocus
                  onSubmitEditing={onSubmit}
                />
              </Box>
              {!!passwordResetError && (
                <MainText variant="l4-regular" color="system.red.950">
                  {passwordResetError}
                </MainText>
              )}
              {resetPasswordSent && (
                <MainText
                  variant="l3-medium"
                  textAlign="center"
                  marginLeft="sm"
                  marginRight="sm"
                >
                  {i18n.t("reset-password-sent")}
                </MainText>
              )}
            </>
          }
          testIDButton="signup-magic-code-submit"
          textButton={i18n.t("web-forget-password-button")}
          onPressButton={onSubmit}
          isButtonDisable={!email || requesting}
          isButtonLoading={requesting}
          firstTextRedirection={i18n.t("web-forget-password-remember")}
          secondTextRedirection={i18n.t("i-login")}
          onPressRedirection={goToLogin}
        />
      </Box>
    </Box>
  );
};

export default WebForgotPasswordScreen;
